// eslint-disable-next-line import/prefer-default-export
export const ADD_SLICE_VIEWS = 'ADD_SLICE_VIEWS';
